import { Component, DestroyRef, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { environment } from '@env/environment';
import { LegalService } from '@core/api/legal-page.service';
import * as fromApp from '@store';
import { LegalConstants } from '@shared/constants/legal.constants';
import { AppConfigService } from '@core/api/app-config.service';

@Component({
  selector: 'fc-legal-page',
  templateUrl: './legal-page.component.html',
  styleUrls: ['./legal-page.component.scss'],
  standalone: false
})
export class LegalPageComponent implements OnInit {
  @ViewChild('legalContent', { static: true })
  pageContent: ElementRef;

  destroyRef = inject(DestroyRef);
  address1: string = '';
  address2: string = '';
  stripeDisclaimer = LegalConstants.STRIPE_DISCLAIMER;
  pageType: string = null;
  pageText: string = null;

  env = environment;

  constructor(
    readonly store: Store<fromApp.AppState>,
    readonly legalService: LegalService,
    readonly appConfigService: AppConfigService,
    readonly route: ActivatedRoute
  ) {
    this.pageType = this.route.snapshot.params.pageType;
  }

  ngOnInit() {
    this.legalService.getLegalPageContent(this.pageType).subscribe({
      next: legalPageContent => {
        this.pageText = legalPageContent;
        this.updateReplacements();
        this.pageContent.nativeElement.innerHTML = this.pageText;
      },
    });
  }

  updateReplacements() {
    if (this.pageText != null) {
      const replacements = {
        '%contactEmail%': this.appConfigService.getValue('fc_contact_email', ''),
        '%contactName%': this.appConfigService.getValue('fc_contact_name', ''),
        '%contactAddress1%': this.appConfigService.getValue('fc_contact_address_line_1', ''),
        '%contactAddress2%': this.appConfigService.getValue('fc_contact_address_line_2', ''),
        '%contactCity%': this.appConfigService.getValue('fc_contact_city', ''),
        '%contactState%': this.appConfigService.getValue('fc_contact_state', ''),
        '%contactZip%': this.appConfigService.getValue('fc_contact_zip', ''),
        '%stripeDisclaimer%': this.stripeDisclaimer,
      };

      for (const [key, value] of Object.entries(replacements)) {
        this.pageText = this.pageText.replace(key, value);
      }
    }
  }
}
